import { parse } from "date-fns";
import { Absence } from "../types/Presence";

export type AbsenceHourRange = {
  from: Date;
  to: Date;
  label: string;
  acronym: string;
};

export function isHourlyAbsence(absence: Absence | null): boolean {
  return absence !== null && absence.hourFrom !== null && absence.hourTo !== null;
}

export function getAbsenceHourRange(
  absence: Absence | null,
  referenceDate: Date,
): AbsenceHourRange | null {
  if (!absence || absence.hourFrom === null || absence.hourTo === null) {
    return null;
  }

  const from = parse(absence.hourFrom, "HH:mm:ss", referenceDate);
  const to = parse(absence.hourTo, "HH:mm:ss", referenceDate);

  return {
    from,
    to,
    label: `${absence.hourFrom.slice(0, 5)}-${absence.hourTo.slice(0, 5)}`,
    acronym: absence.acronym,
  };
}
